import React from 'react'
import HoverWrapper from '../../../../Components/HoverWrapper'
import QuestionMark from '../../../../Components/Icons/QuestionMark'

const headers = [
  {
    id: 'cityName',
    numeric: true,
    disablePadding: false,
    label: 'City',
    sortable: true,
    countryLevelHeader: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'clientName',
    numeric: true,
    disablePadding: false,
    label: 'Client',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'campaignName',
    numeric: true,
    disablePadding: false,
    label: 'Campaign Name',
    sortable: false,
  },
  {
    id: 'week',
    numeric: true,
    disablePadding: false,
    label: 'Week',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'date',
    numeric: true,
    disablePadding: false,
    label: 'Date',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'time',
    numeric: true,
    disablePadding: false,
    label: 'Time',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'timeOfDay',
    numeric: true,
    disablePadding: false,
    label: 'Time of day',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'dayOfWeek',
    numeric: true,
    disablePadding: false,
    label: 'Day of week',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'canBeSpied',
    numeric: true,
    disablePadding: false,
    label: 'Can be spied',
    sortable: false,
  },
  {
    id: 'spy',
    numeric: true,
    disablePadding: false,
    label: 'Spy',
    sortable: false,
  },
  {
    id: 'location',
    numeric: true,
    disablePadding: false,
    label: 'Location',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'brandAmbassador',
    numeric: true,
    disablePadding: false,
    label: 'BA',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'flyerCode',
    numeric: true,
    disablePadding: false,
    label: 'Code',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'tag',
    numeric: true,
    disablePadding: false,
    label: 'Tag',
    sortable: false,
  },
  {
    id: 'flyersDistributed',
    numeric: true,
    disablePadding: false,
    label: 'Flyer distributed',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'scans',
    numeric: true,
    disablePadding: false,
    label: 'Scans',
    sortable: false,
  },
  {
    id: 'metric1',
    numeric: true,
    disablePadding: false,
    label: 'Metric I',
    sortable: false,
  },
  {
    id: 'metric2',
    numeric: true,
    disablePadding: false,
    label: 'Metric II',
    sortable: false,
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
    sortable: true,
    alwaysShowSortIcon: true,
  },
  {
    id: 'rating',
    numeric: true,
    disablePadding: false,
    label: (
      <HoverWrapper
        style={{ maxWidth: 450 }}
        title="Rating Helper"
        hoverText={
          <div>
            <div>
              <strong>How is the Rating Calculated?</strong>
            </div>
            <br />
            <div>
              Mission ratings measure how successful a mission was. They are
              based on three key results, measured <strong>7 days after</strong>{' '}
              the mission is completed:
            </div>
            <div>
              <ul>
                <li>
                  <strong>Conversions:</strong> How many desired actions
                  resulted from the flyers (accounts for 45% of the rating).
                </li>
                <li>
                  <strong>Scan:</strong> How many QR codes or links were
                  scanned/used (accounts for 45% of the rating).
                </li>
                <li>
                  <strong>Flyers Distributed:</strong> The percentage of the
                  assigned flyers that were actually given out (accounts for 10%
                  of the rating).
                </li>
              </ul>
            </div>
            <div>
              <em>
                (The 7-day wait allows time for people to scan codes and convert
                after receiving a flyer).
              </em>
              <br />
              <br />
              <strong>Why Might a Rating Be Missing?</strong>
              <br /> There are two main reasons you might not see a rating yet:
            </div>
            <div>
              <ol>
                <li>
                  <strong>It's Too Soon:</strong> Ratings only appear{' '}
                  <strong>7 days after</strong> the mission was completed.
                  Please check back after this period.
                </li>
                <li>
                  <strong>Incomplete Mission Information:</strong> The system
                  needs all the necessary details to calculate the rating. Check
                  if the mission setup is complete, including:
                  <br />
                  <ul>
                    <li>City, Campaign, and Location information.</li>
                    <li>A flyer pack correctly assigned to the mission.</li>
                    <li>
                      Confirmation that flyers were distributed (checkout
                      process completed).
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
            <div>
              If it's been more than 7 days and all information seems correct,
              please contact support.
            </div>
          </div>
        }
        uniqueId="rating-global-planing"
        element={
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <span>Rating</span> <QuestionMark style={{ marginRight: 4 }} />
          </span>
        }
      />
    ),
    sortable: false,
  },
]

const presets = [
  { id: 'noPresets', label: 'No Preset' },
  { id: 'noShow', label: 'No-Show' },
  { id: 'liveMissions', label: 'Live Missions' },
  { id: 'yesterdayMissions', label: "Yesterday's missions" },
  { id: 'todayMissions', label: "Today's missions" },
  { id: 'tomorrowMissions', label: "Tomorrow's missions" },
]

const countryLevelPresets = [
  { id: 'noPresets', label: 'No Preset' },
  { id: 'noShow', label: 'No-Show' },
  { id: 'yesterdayMissions', label: "Yesterday's missions" },
  { id: 'todayMissions', label: "Today's missions" },
  { id: 'tomorrowMissions', label: "Tomorrow's missions" },
]

const defaultModalState = {
  text: '',
  shiftId: null,
  isOpen: false,
  type: null,
  canBeSpied: null,
  missionId: null,
  userId: null,
}

const MODAL_TYPES = {
  UPDATE_MISSION: 'UPDATE_MISSION',
  DELETE_SPY: 'DELETE_SPY',
  ADD_MISSION_ON_SHIFT: 'ADD_MISSION_ON_SHIFT',
}

const exportHeaders = [
  'City Name',
  'Client Name',
  'Campaign Name',
  'Week',
  'Date',
  'Time',
  'Time of Day',
  'Day of Week',
  'Can be Spied',
  'Spy',
  'Location',
  'Brand Ambassador',
  'Flyer Code',
  'Tag',
  'Flyers Distributed',
  'Scans',
  'Metric 1',
  'Metric 2',
  'Status',
  'Rating',
]

export {
  headers,
  presets,
  countryLevelPresets,
  defaultModalState,
  MODAL_TYPES,
  exportHeaders,
}
